<template>
   <div v-wechat-title="title" class="schedule-surgery">
        <crud-facecade
            ref="surgery-list"
            :url="url"
             :tableStyle="tableStyle"
            :disableOrderDefaultSort="true"
            :columns="columnList"
            :buttons="[]"
            :tableHeight="tableHeight"
            dialogWidth="90%"
            :selection="true"
            :customFixedColumns="customScheduleFixedColumns"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :columnConfig="true"
            :showSequence="false"
            :filterSpan="[15, 5, 6]"
            :stripe="scheduleSurgeryRowStyleConfig==`0`"
            :row-style="rowStyle"
             @rowDbclick="rowDbclick"
             @selectionChange="checkedRow"
             @loadSurgeryEditView="loadSurgeryEditView"
            @extrabutton-click="ExtraButtonClick"
        >
          <slot slot="filter">
                <el-col :md="5" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="scheduling_date" style="width: 160px"></item-input>
                </el-col>
                <el-col :md="15" :xl="15" class="align-left">
                    <el-button :type="isLoadToSchedule ? 'primary' : 'plain'" size="mini" @click="LoadUnScheduled()" title="待排程">
                        <span style="float: right; padding-right: 1px">待排程({{ unScheduledLength }})</span></el-button
                    >
                    <el-button :type="isLoadScheduled ? 'primary' : 'plain'" size="mini" @click="LoadScheduled()" title="已排程">
                        <span style="float: right; padding-right: 1px">已排程({{ ScheduledLength }})</span>
                    </el-button>
                    <el-button :type="isLoadAll ? 'primary' : 'plain'" size="mini" @click="LoadAllScheduled()" title="全部">
                        <span style="float: right; padding-right: 1px">全部({{ unScheduledLength+ScheduledLength }})</span>
                    </el-button>
                    <span  style="font-weight: 600;">共:{{unScheduledLength+ScheduledLength}}台</span>
                </el-col>
                <el-col :md="6" :xl="6">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                 <el-col :md="3" :xl="2">
                    <item-input type="select" v-model="selectsurgeryType" :options="surgeryTypes" placeholder="类型" @input="changed"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-dropdown @command="cancel">
                    <el-button type="primary" size="mini" v-show="isHaveCancelSchedule(`all`)">取消驳回<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cancelSchedule" v-show="isHaveCancelSchedule(`cancelSchedule`)">取消排程</el-dropdown-item>
                        <el-dropdown-item command="cancelSurgery" v-has-permission="cancelSurgeryPermission">取消手术</el-dropdown-item>
                        <el-dropdown-item command="rejectApprove" v-show="isHaveCancelSchedule(`rejectApprove`)">驳回审核</el-dropdown-item>
                        <el-dropdown-item command="rejectApply" v-show="isHaveCancelSchedule(`rejectApply`)">驳回申请</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="loadScheduleHelper">
                    <el-button type="primary" size="mini" v-show="ishavehelpSection(`all`)">排程助手<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="autoOneKeySchedule" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpOneKeySchedule`)">一键排程</el-dropdown-item>
                        <el-dropdown-item command="changeRoom" v-show="ishavehelpSection(`helpChangeRoom`)">更换手术间</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printSurenry">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in printSurgeryConfigs" :key="item.code" v-text="item.value" :command="item"></el-dropdown-item>
                        <!-- <el-dropdown-item command="PC008">打印手术信息</el-dropdown-item>
                        <el-dropdown-item command="PC009">打印首台通知</el-dropdown-item>
                         <el-dropdown-item command="PC007">打印排程列表</el-dropdown-item> -->
                        <el-dropdown-item command="ExportExcel">导出Excel</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
          <div ref="roomrow" slot="table-title">
                <el-row style="display: flex; align-items: center">
                    <el-col :md="23" :xl="23" class="align-left">
                        <div key="noscrollpane" style="position: relative; overflow: hidden; width: 100%; text-align: left">
                                <div>
                                    <div
                                        class="height50 inline-block margin2 margin-none-v cursor-pointer room"
                                        style="min-width: 80px"
                                        :class="{ 'is-close': !room.is_open, 'is-operating': room.is_operating}"
                                        v-for="room in operationRoom"
                                        :key="room.id"
                                    >
                                            <div @click="LoadActiveRoomData($event, room)" class="height50">
                                                <el-row class="height-p100">
                                                    <el-col :span="2" class="height-p100 title"> &nbsp; </el-col>
                                                    <el-col
                                                        :span="22"
                                                        class="content padding5 padding-none-v height-p100"
                                                        :class="{ active: active_room_id == room.id || scrolling_in_id == room.id }"
                                                        :style="styleObject(active_room_id == room.id || scrolling_in_id == room.id, room.room_setting)"
                                                    >
                                                        <el-row class="font-size10" @click="active_room_id = room.id" style="white-space: nowrap; height: 22px">
                                                            <el-col :span="10" class="line-height20"  key="noscroll_norejectCount">
                                                                {{ room.done }}/{{ room.total }}
                                                            </el-col>
                                                        </el-row>
                                                        <span class="align-center" style="white-space: nowrap; line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex">{{
                                                            room.name
                                                        }}</span>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                    </div>
                                </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <template slot="operatingroom" slot-scope="{ row }">
                   <el-input type="select"  :disabled="row.enum_surgery_status!=20 && row.enum_surgery_status!=10 " v-model="row.operatingroom" @click.native="openRoomSelect(row)" :options="[]" placeholder=""></el-input>
            </template>
            <template slot="surgeon" slot-scope="{ row }">
                <div style="min-width: 90px; white-space: nowrap">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}{{ row.surgeon_assistants && `(助)${row.surgeon_assistants}`}}</span>
                </div>
            </template>
            <template slot="plan_anes_doctor" slot-scope="{ row }">
                <el-input
                 :disabled="row.enum_surgery_status!=20 && row.enum_surgery_status!=10 "
                    :key="row.id"
                    :value="row.plan_anes_doctor"
                    placeholder="请选择"
                    @click.native="openCircuitNurseDialog(row,3)"
                />
            </template>
            <template slot="plan_anes_assistants" slot-scope="{ row }">
                <el-input
                   :disabled="row.enum_surgery_status!=20 && row.enum_surgery_status!=10 "
                    :value="row.plan_anes_assistants"
                    placeholder="请选择"
                    @click.native="openCircuitNurseDialog(row,4)"
                />
            </template>
            <template slot="plan_circuit_nurse" slot-scope="{ row }">
                <el-input
                     :disabled="row.enum_surgery_status!=20 && row.enum_surgery_status!=10 "
                    :value="row.plan_circuit_nurse"
                    placeholder="请选择"
                    @click.native="openCircuitNurseDialog(row,5)"
                />
            </template>
                <template slot="plan_equipment_nurse" slot-scope="{ row }">
                <el-input
                     :disabled="row.enum_surgery_status!=20 && row.enum_surgery_status!=10 "
                    :value="row.plan_equipment_nurse"
                    placeholder="请选择"
                    @click.native="openCircuitNurseDialog(row,6)"
                />
            </template>
        </crud-facecade>
         <EditSurgery :surgeryId="edit.surgeryId" :editButtons="editButtons" :visible.sync="edit.dialogFormVisible" @after-save="afterSave" @save="ReloadListData"></EditSurgery>

         <!-- 手术间互换弹层 -->
<cus-dialog
  title="手术间互换"
  :visible.sync="changeroomVisible"
  width="720px"
  @confirm="confirmChangeRoom"
>
  <el-row :gutter="10">
    <el-col
      v-for="r in selectableRooms"
      :key="r.id"
      :xs="12"
      :sm="8"
      :md="6"
      :lg="4"
    >
      <div
        class="room-card"
        :class="{ active: changeroomids.includes(r.id)}"
        @click="setchangeroomids(r.id)"
      >
        {{ r.name }}<br />
        <small>{{ r.total }}</small>
      </div>
    </el-col>
  </el-row>
</cus-dialog>

        <!-- 行内选择手术间弹层 -->
<cus-dialog
  title="选择手术间"
  :visible.sync="roomSelectVisible"
  width="720px"
  @confirm="confirmRoomSelect"
>
  <el-row :gutter="10">
    <el-col
      v-for="r in selectableRooms"
      :key="r.id"
      :xs="12"
      :sm="8"
      :md="6"
      :lg="4"
    >
      <div
        class="room-card"
        :class="{ active: selectedRoomId === r.id }"
        @click=" selectedRoomId = r.id"
      >
        {{ r.name }}<br />
        <small>{{ r.total }}</small>
      </div>
    </el-col>
  </el-row>
</cus-dialog>

<!-- 选择巡回护士弹层 -->
<cus-dialog
  title="选择人员"
  :visible.sync="circuitNurseVisible"
  :clearVisible="true"
  width="660px"
  @confirm="confirmCircuitNurse(duty)"
  @clearWorker="ClearWorker(duty)"
  @cancel="circuitNurseVisible=false"
>
  <el-row>
    <!-- 搜索 -->
    <el-input
      v-model="nurseKeyword"
      placeholder="输入姓名/简拼搜索"
      size="small"
      ref="nurseKeywordRef"
      prefix-icon="el-icon-search"
      style="margin-bottom:8px"
    />
  </el-row>
  <!-- 已排（蓝色） -->
  <div class="group-title blue align-left">今日已排</div>
  <el-row :gutter="10" class="nurse-group">
    <el-col
      v-for="n in todaySelectedNurses(duty)"
      :key="n.value"
      :span="3"
    >
      <div
        class="nurse-tag blue"
        :class="{selected: localSelectedNurses.includes(n.value)}"
        @click="toggleNurse(n.value)"
      >
        {{ n.label }}

        <!-- <div class="delete-icon" @click="removePerson(n.value)">
            ×
        </div> -->
      </div>
    </el-col>
  </el-row>

  <!-- 未排（黄色） -->
  <div class="group-title yellow align-left">今日未排</div>
  <el-row :gutter="10" class="nurse-group">
    <el-col
      v-for="n in todayUnselectedNurses(duty)"
      :key="n.value"
      :span="3"
    >
      <div
        class="nurse-tag yellow"
        :class="{selected: localSelectedNurses.includes(n.value)}"
        @click="toggleNurse(n.value)"
      >
        {{ n.label }}
      </div>
    </el-col>
  </el-row>
</cus-dialog>
        <cus-dialog :title="printSurenryForm.title" :visible.sync="printSurenryForm.dialogFormVisible" width="30%" @confirm="printSurenryByTime()">
            <div class="margin10 margin-none-h align-left" v-if="printSurenryForm.type == 4">
                <item-input type="multiselect" :showCount="3" :collapseTags="false" v-model="printSurenryForm.wardids" :options="operation_ward_auth" placeholder="请选择手术区"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left" v-if="printSurenryForm.type == 3">
                请选择手术间：<item-input style="width: 150px" type="multiselect" v-model="printSurenryForm.roomids" :options="printSurenryForm.rooms" placeholder="请选择手术间"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                请 指 定 时 间：<item-input style="width: 300px" v-if="printSurenryForm.type == 5" type="datetimerange" v-model="printSurenryForm.from_to" :noPadding="true"></item-input>
                <item-input style="width: 300px" v-else type="daterange" v-model="printSurenryForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>

         <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import EditSurgery from './EditSurgery.vue'
import AddSurgery from './AddSurgery.vue'
export default {
    name: `ScheduleSurgerySimple`,
    components: { draggable, EditSurgery, AddSurgery },
    props: {},
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`驳回理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`驳回理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }
        // 读取暂存的查询条件
        let schedulingCondition = sessionStorage.getItem(`consdSimple`)
        let sessionSchedulingDate = this.$moment().add(0, `days`).format(`YYYY/MM/DD 00:00:00`)
        if (schedulingCondition && JSON.parse(schedulingCondition) != null) {
            var obj = JSON.parse(schedulingCondition)
            sessionSchedulingDate = obj.scheduling_date
        }
        return {
            title: `手术排程`,
            editButtons: [
                {
                    label: `确认排程`,
                    type: `default`,
                    permission: `ApplySurgery:ConfirmSchedule`
                }
            ],
            cancelSurgeryPermission: `scheduling:cancel_surgery`, // 取消手术
            overrule: {
                title: `手术驳回`,
                dialogFormVisible: false,
                emitBtnName: ``,
                data: {},
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `驳回原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ]
            },
            roomStyle: {
                color: ``,
                backgroundColor: ``,
                fontSize: ``,
                activecolor: ``,
                activebackgroundColor: ``,
                activefontSize: ``,
                isEnable: `0`, // 是否启用人员配置背景色
                bgColor: ``, // 人员配置对应背景色展示
                activebgColor: `` // 人员配置对应手术间选中时背景色展示
            },
            printSurenryForm: {
                dialogFormVisible: false,
                from_to: [],
                code: ``,
                type: 0,
                roomids: null,
                extradata: null,
                rooms: [],
                wardids: null,
                title: `日期区间打印`
            },
            printSurgeryConfigs: [],
            IntelligenceSurgeryPermission: `scheduling:intelligence`, // 排程助手按钮显示权限
            thistableHeight: 0,
            scrolling_in_id: 0, // 当前拖动操作的手术间Id
            dragEventTager: null, // 当前鼠标拖动触发的对象
            setIntervalScroll: {}, // 滚动定时器
            isShowRejectCount: this.$root.IsShowRejectCount,
            isAutoScheduledSequence: this.$root.IsAutoScheduledSequence,
            settingRoomBgColor: this.$root.settingRoomBgColor,
            ScheduleRoomStyleSetting: this.$root.ScheduleRoomStyleSetting,
            scheduleSurgeryStyle: this.$root.ScheduleSurgeryStyle,
            isShowMoreRoom: false,
            active_room_id: 0, // 当前手术间Id
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            o_dic_operating_ward_id: undefined, // 排程手术区
            isLoadToSchedule: false, // 选中待排程卡片
            isLoadScheduled: false, // 选中已排程卡片
            isLoadAll: false, // 选中全部卡片
            unschedulelist: [], // 待排程列表
            unScheduledLength: 0, // 待排程数量
            ScheduledLength: 0, // 已排程数量
            scheduledlist: [], // 已排程列表
            allschedules: [], // 显示数据
            selectsurgeryType: 0,
            scheduleSurgeryRowStyleConfig: this.$root.ScheduleSurgeryRowStyleConfig || `0`,
            scheduling_date: schedulingCondition
                ? sessionSchedulingDate
                : this.$moment().add(0, `days`).format(`YYYY/MM/DD 00:00:00`), // 排程日期
            localSelectedNurses: [], // 弹层多选确定
            roomSelectVisible: false, // 弹层显隐
            circuitNurseVisible: false, // 弹层显隐
            selectableRooms: [], // 当天全部可选手术间
            selectedRoomId: null, // 当前选中手术间
            rowToAssign: null, // 当前要分配的行数据
            nurseKeyword: ``, // 弹层内搜索字
            operation_ward_all: undefined,
            changeroomids: [],
            changeroomVisible: false, // 弹层显隐
            isEnableFilterStatusForExportExcel: this.$root.IsEnableFilterStatusForExportExcel, // 是否开启导出Excel 按状态过滤数据
            exportExcel: {
                title: `导出数据过滤`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                data: {},
                exportDatas: [],
                dialogFormVisible: false,
                Columns: [
                    {
                        type: `checkboxgroup`,
                        prop: `status`,
                        label: `状态:`,
                        options: [
                            { label: `已排程`, value: `已排程` },
                            { label: `进行中`, value: `进行中` },
                            { label: `手术结束`, value: `手术结束` },
                            { label: `苏醒中`, value: `苏醒中` },
                            { label: `苏醒结束`, value: `苏醒结束` }
                        ],
                        colspan: 24,
                        default: [`已排程`, `进行中`, `手术结束`, `苏醒中`, `苏醒结束`]
                    }
                ]
            },
            checkedRows: [],
            ScheduleNurseFilterSection: this.$root.ScheduleNurseFilterSection,
            duty: 0,
            edit: {
                dialogFormVisible: false,
                surgeryId: 0
            },
            url: {
                // 待排程和已排程，调用
                area: `schedule_surgerysimple`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return this.loadSurgeries()
                },
                putMany: data => {
                    let that = this
                    that.putScheduled(data)
                }
            }
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.loadRoomStyle()
        this.isLoadToSchedule = false
        this.isLoadScheduled = false
        this.isLoadAll = true
        if (this.scheduleSurgeryRowStyleConfig && this.scheduleSurgeryRowStyleConfig.trim() != `0`) {
            this.scheduleSurgeryRowStyleObj = eval(
                `(` + this.scheduleSurgeryRowStyleConfig + `)`
            )
        }
        console.log(this.scheduleSurgeryRowStyleObj)
        this.lastalertmsg = ``
    },
    mounted() {
        this.ReloadRoom()
        this.loadPrintSurgeryConfig()
    },
    computed: {
        ...mapGetters([
            `operation_ward`,
            `sysuser/workers_by_duty`,
            `surgery/anaesthesia_method`,
            `sysuser/workers_by_dutyNew`,
            `sys_enums`,
            `listview/remove_item`,
            `operation_ward_auth`,
            `operation_ward_auth_disabled`,
            `screenHeight`,
            `permissions`,
            `active_ward`,
            `section_auth`,
            `operation_room_auth`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                console.log(`isWorkerByDuty==0,获取的医生`, this[`sysuser/workers_by_duty`])
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                console.log(`isWorkerByDuty==0,获取的巡回护士`)
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        customScheduleFixedColumns() {
            // 获取排程界面自定义固定列参数,:手术间,台次,操作
            if (this.$root.CustomScheduleFixedColumns && this.$root.CustomScheduleFixedColumns.trim()) {
                console.log(`gggggggggggggggg`, this.$root.CustomScheduleFixedColumns.trim().split(`,`))
                return this.$root.CustomScheduleFixedColumns.trim().split(`,`)
            }
            return []
        },
        surgeryTypes() {
            var r = _.map(this.sys_enums && this.sys_enums.Enum_SurgeryType, d => {
                return {
                    value: d.value,
                    label: d.label
                }
            })
            return [{ value: 0, label: `全部类型` }].concat(r)
        },
        tableStyle() {
            return this.scheduleSurgeryStyle
        },
        tableHeight() {
            return (this.screenHeight && this.screenHeight - this.thistableHeight - 185) || 0
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && this.active_ward.code == `手术区`) {
                    this.o_dic_ward_id = this.active_ward.origion
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        operationRoom: {
            get() {
                let r = []
                r = this.operation_ward_all && this.operation_ward_all[this.dic_operating_ward_id]
                r = _.orderBy(r, `display_order`) || []
                return r
            },
            set() {}
        },
        columnList() {
            // let me = this
            // let listeditWorker = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:list_editWorker`) === -1
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `patientname`,
                    label: `姓名`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `bedno`,
                    label: `床号`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `visitno`,
                    label: this.T(`surgery_scheduling.visit_no`),
                    queryable: true,
                    isListable: true,
                    area: [1, 2]
                },

                {
                    type: `string`,
                    prop: `infectious`,
                    label: `传染病`,
                    width: `350`,
                    isListable: true,
                    area: [1, 2],
                    tooltip: false
                },

                {
                    type: `select`,
                    prop: `enum_surgery_status`,
                    label: `手术状态`,
                    isListable: true,
                    options: this.sys_enums.SurgeryStatus || [],
                    width: `100`,
                    readonly: true,
                    area: [1, 2]
                },
                {
                    type: `number`,
                    prop: `sequence`,
                    label: `申请台次`,
                    isListable: true,
                    width: `100`,
                    readonly: true,
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `enum_surgerytype`,
                    label: `手术类型`,
                    isListable: true,
                    options: this.sys_enums.Enum_SurgeryType || []
                },
                {
                    type: `selectAllowCreate`,
                    prop: `scheduledsequence`,
                    allowCreate: true,
                    label: `台次`,
                    isListable: true,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status != 20
                    },
                    area: [1, 2],
                    options: (that, { row }) => {
                        let sequence = []
                        for (let index = 1; index <= 20; index++) {
                            var seq = {
                                label: index,
                                value: index
                            }
                            sequence.push(seq)
                        }
                        return sequence
                    }
                },
                {
                    type: `string`,
                    prop: `sectionname`,
                    label: `科室`,
                    width: `100`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `operatingward`,
                    label: `手术区`,
                    width: `100`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `operatingroom`,
                    label: `手术间`,
                    width: `150`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `surgicalsite`,
                    label: `手术部位`,
                    width: `150`,
                    isListable: true,
                    queryable: false,
                    area: [1, 2]
                },
                {
                    type: `datetime`,
                    prop: `applytime`,
                    label: `申请时间`,
                    width: `120`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `datetime`,
                    prop: `plantime`,
                    label: `计划开始时间`,
                    width: `130`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `disease`,
                    label: `术前诊断`,
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `surgery`,
                    label: `手术名称`,
                    queryable: true,
                    isListable: true,
                    width: `180`,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `anaesthesiamethod`,
                    label: `计划麻醉方式`,
                    width: `120`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true,
                    width: `300`,
                    // colspan: 6,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: this.T(`his_id`),
                    width: `120`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `enum_surgeryscale`,
                    label: `手术等级`,
                    isListable: true,
                    width: `100`,
                    options: this.sys_enums.Enum_SurgeryScale || [],
                    area: [1, 2]
                }, {
                    type: `custom`,
                    prop: `surgeon`,
                    label: this.T(`Schedule.plan_surgeon`),
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                }, {
                    type: `custom`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`Schedule.plan_anes_doctor`),
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                }, {
                    type: `custom`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`Schedule.plan_anes_assistants`),
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                }, {
                    type: `custom`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`Schedule.plan_circuit_nurse`),
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                }, {
                    type: `custom`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`Schedule.plan_equipment_nurse`),
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                }
            ]
            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)

            return list
        },
        columnList2() {
            let r = _.filter(this.columnList, d => {
                return d.area.indexOf(2) > -1
            }).concat([
                {
                    type: `buttongroup`,
                    prop: `oper2`,
                    width: `60`,
                    label: `操作`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain is-circle`,
                            label: ``,
                            icon: `el-icon-edit-outline`,
                            type: `primary`,
                            emit: `loadSurgeryEditView`,
                            permission: `default`,
                            tooltip: `编辑`
                        }
                    ]
                }
            ])
            console.log(`rrrrrrrrrrrrrr`, r)
            return r
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        },
        /* 弹层内搜索（实时过滤） */
        getCircuitNurseOptions() {
            return function(duty) {
                let works = []
                if (duty == `3` || duty == `4`) {
                    works = this.isWorkerByDuty === `0`
                        ? this.worker[`医生`] || []
                        : this.worker[`麻醉医生`] || []
                } else if (duty == `5` || duty == `6`) {
                    works = this.isWorkerByDuty === `0`
                        ? this.worker[`护士`] || []
                        : this.worker[`巡回护士`] || []
                    if (this.ScheduleNurseFilterSection == `1`) {
                        let rsectionid = this.currentRow.dic_section_id
                        console.log(`works`, works)
                        if (rsectionid != null) {
                            works = _.filter(works, function(n) {
                                return (n.sectionids && n.sectionids.includes(rsectionid)) || n.dic_section_id == rsectionid
                            })
                        }
                    }
                }
                let kw = this.nurseKeyword.toLowerCase()
                return kw
                    ? works.filter(
                        n =>
                            n.label.toLowerCase().includes(kw) ||
            (n.jianpin && n.jianpin.toLowerCase().includes(kw))
                    )
                    : works
            }
        },
        todaySelectedNurses() {
            // 计算今日已排
            return function(duty) {
                let all = this.getCircuitNurseOptions(duty)
                let scheduledWorkerIds = []
                if (duty == 3 || duty == 4) {
                    scheduledWorkerIds = this.allschedules.flatMap(s => s.workerlist).filter(i => {
                        return i.enum_duty == 3 || i.enum_duty == 4
                    }).map(n => n.id)
                } else if (duty == `5` || duty == `6`) {
                    scheduledWorkerIds = this.allschedules.flatMap(s => s.workerlist).filter(i => {
                        return i.enum_duty == 5 || i.enum_duty == 6
                    }).map(n => n.id)
                }
                return all.filter(n => scheduledWorkerIds.includes(n.value))
            }
        },
        todayUnselectedNurses() {
            // 计算今日未排
            return function(duty) {
                let all = this.getCircuitNurseOptions(duty)
                let scheduledWorkerIds = []
                if (duty == 3 || duty == 4) {
                    scheduledWorkerIds = this.allschedules.flatMap(s => s.workerlist).filter(i => {
                        return i.enum_duty == 3 || i.enum_duty == 4
                    }).map(n => n.id)
                } else if (duty == `5` || duty == `6`) {
                    scheduledWorkerIds = this.allschedules.flatMap(s => s.workerlist).filter(i => {
                        return i.enum_duty == 5 || i.enum_duty == 6
                    }).map(n => n.id)
                }
                return all.filter(n => !scheduledWorkerIds.includes(n.value))
            }
        },
        styleObject() {
            return function(active, setting) {
                let style = {
                    color: active ? this.roomStyle.activecolor : this.roomStyle.color,
                    fontSize: active ? this.roomStyle.activefontSize : this.roomStyle.fontSize
                }
                if (this.roomStyle.isEnable === `1`) {
                    // 读取参数配置中的颜色，没有配置数据时默认白色
                    let backgroundColor = this.roomStyle.backgroundColor == `` ? `white` : this.roomStyle.backgroundColor
                    let activebackgroundColor = this.roomStyle.activebackgroundColor == `` ? `white` : this.roomStyle.activebackgroundColor
                    let bgColor = this.roomStyle.bgColor == `` ? `white` : this.roomStyle.bgColor
                    let activebgColor = this.roomStyle.activebgColor == `` ? `white` : this.roomStyle.activebgColor
                    // 配置了麻醉医生，没有配置巡回护士或器械护士
                    if (setting.anesthetist_id && !setting.circuit_nurse_id && !setting.equipment_nurse_id) {
                        style.background = active ? `linear-gradIEnt(${activebgColor} 50%,${activebackgroundColor} 50%)` : `linear-gradIEnt(${bgColor} 50%,${backgroundColor} 50%)`
                    } else if (!setting.anesthetist_id && (setting.circuit_nurse_id || setting.equipment_nurse_id)) {
                        // 配置了巡回护士或器械护士，没有配置麻醉医生
                        style.background = active ? `linear-gradIEnt(${activebackgroundColor} 50%,${activebgColor} 50%)` : `linear-gradIEnt(${backgroundColor} 50%,${bgColor} 50%)`
                    } else if (setting.anesthetist_id && (setting.circuit_nurse_id || setting.equipment_nurse_id)) {
                        // 配置了麻醉医生和巡回护士/器械护士
                        style.background = active ? `linear-gradIEnt(${activebgColor} 50%,${activebgColor} 50%)` : `linear-gradIEnt(${bgColor} 50%,${bgColor} 50%)`
                    } else {
                        style.backgroundColor = active ? this.roomStyle.activebackgroundColor : this.roomStyle.backgroundColor
                    }
                } else {
                    style.backgroundColor = active ? this.roomStyle.activebackgroundColor : this.roomStyle.backgroundColor
                }
                return style
            }
        }
    },
    beforeDestroy() {
        // 暂存查询条件
        var schedulingCondition = {
            scheduling_date: this.scheduling_date
        }
        sessionStorage.setItem(`consdSimple`, JSON.stringify(schedulingCondition))
    },
    methods: {
        isHaveCancelSchedule(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return (
                    this.permissions &&
                    this.permissions.findIndex(
                        item => item.permission === `scheduling:cancelSchedule` || item.permission === `scheduling:rejectApprove` || item.permission === `scheduling:rejectApply`
                    ) != -1
                )
            }
        },
        cancelScheduleAll() {
            let that = this

            let pmise = new Promise((resolve, reject) => {
                let chckrows = _.filter(this.checkedRows, { enum_surgery_status: 20 })
                if (chckrows.length == 0) {
                    this.$message.warning(`请选择已排程手术!`)
                    return
                }
                if (chckrows.length > 0) {
                    let msgs = ``
                    chckrows.map(d => {
                        msgs += `(“${d.patientname}”、“${d.visitno || `--`}”)、`
                    })
                    msgs = msgs.slice(0, msgs.length - 1)
                    return this.$confirm(`请确认是否取消${msgs}的排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve(chckrows)
                        })
                        .catch(e => {
                            reject([])
                        })
                } else {
                    that.$message.success(`请选择已排程手术!`)
                }
            })

            pmise
                .then(crs => {
                    let roomIds = []
                    let reqs =
                        crs &&
                        crs.map(d => {
                            roomIds.push(d.dic_operating_room_id)
                            return this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${d.id}`)
                        })
                    this.myaxios
                        .all(...reqs)
                        .then(data => {
                            this.ReScheduleSurgeries(roomIds).then(ds => {
                                this.ReloadRoom()
                                this.ReloadListData()
                                this.$message.success(`取消排程成功`)
                            })
                        })
                        .catch(e => {})
                })
                .catch(e => {})
        },
        cancel(command) {
            let that = this
            if (command == `cancelSchedule`) {
                that.cancelScheduleAll()
            }
            if (command == `cancelSurgery`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApprove`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApply`) {
                that.loadingOverruleView(command)
            }
        },
        loadingOverruleView(btnName) {
            let that = this
            this.surgeryIds = []
            let rejectApplyMsgs = ``
            if (that.checkedRows && that.checkedRows.length > 0) {
                if (btnName == `rejectApply`) {
                    // 驳回申请
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patientname}”、“${d.visitno || `--`}”)、`
                        }
                    })
                } else if (btnName == `rejectApprove`) {
                    // 驳回审批
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patientname}”、“${d.visitno || `--`}”)、`
                        }
                    })
                } else {
                    // 取消手术
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patientname}”、“${d.visitno || `--`}”)、`
                        }
                    })
                }
            }
            let msg = btnName == `cancelSurgery` ? `取消` : `驳回`
            if (this.surgeryIds.length == 0) {
                if (btnName == `rejectApply`) {
                    this.$message.warning(`请选择待排程或已排程的手术!`)
                }
                if (btnName == `rejectApprove`) {
                    this.$message.warning(`请选择待排程的手术!`)
                }
                if (btnName == `cancelSurgery`) {
                    this.$message.warning(`请选择已排程的手术!`)
                }
                return
            }
            // 增加驳回前提示
            rejectApplyMsgs = rejectApplyMsgs.slice(0, rejectApplyMsgs.length - 1)
            if (btnName == `rejectApply`) {
                rejectApplyMsgs += `的手术申请`
            } else if (btnName == `rejectApprove`) {
                rejectApplyMsgs += `的手术审核`
            } else {
                rejectApplyMsgs += `的已排程手术`
            }
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将${msg}${rejectApplyMsgs}`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    if (btnName == `cancelSurgery`) {
                        this.overrule.title = `取消手术`
                        col.label = `取消原因`
                    }
                    this.overrule.emitBtnName = btnName
                    this.overrule.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        saveOverrule(row) {
            let that = this
            let msg = that.overrule.emitBtnName == `cancelSurgery` ? `取消` : `驳回`
            if (that.surgeryIds.length == 0) {
                if (that.overrule.emitBtnName == `rejectApply`) {
                    this.$message.warning(`请选择待排程或已排程的手术!`)
                }
                if (that.overrule.emitBtnName == `rejectApprove`) {
                    this.$message.warning(`请选择待排程的手术!`)
                }
                if (that.overrule.emitBtnName == `cancelSurgery`) {
                    this.$message.warning(`请选择已排程的手术!`)
                }
                return
            }

            try {
                that.surgeryIds.map(d => {
                    let requestData = {
                        id: d,
                        visit_info: null,
                        reject_reason: row.reject_reason
                    }
                    if (that.overrule.emitBtnName == `rejectApply`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/Reject`, requestData)
                        req.then(data => {
                            let rooIds = [that.active_room_id]
                            that.ReScheduleSurgeries(rooIds).then(ds => {
                                that.ReloadRoom()
                                that.ReloadListData()
                            })

                            // 调用手术回写
                            let pushModel = {
                                surgeryId: d,
                                surgeryInfoSendType: 1
                            }
                            var reps = this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, pushModel)
                            reps.then(data => {})
                        })
                    }
                    if (that.overrule.emitBtnName == `rejectApprove`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/RejectApprove`, requestData)
                        req.then(data => {
                            this.ReloadRoom()
                            this.ReloadListData()
                        })
                    }
                    if (that.overrule.emitBtnName == `cancelSurgery`) {
                        let req = this.myaxios.put(`/api/Preoperative/Schedule/CancelSurgery?surgeryId=${requestData.id}&&reason=${requestData.reject_reason}`)
                        req.then(data => {
                            let rooIds = [that.active_room_id]
                            that.ReScheduleSurgeries(rooIds).then(ds => {
                                that.ReloadRoom()
                                that.ReloadListData()
                            })
                        })
                    }
                })
                that.$message.success(`手术${msg}成功`)
                that.surgeryIds = []
                that.overrule.dialogFormVisible = false
            } catch (e) {
                that.$message.error(`手术${msg}失败`)
            }
        },
        rowDbclick({ row }) {
            console.log(row)
            this.edit.surgeryId = row.id
            this.edit.dialogFormVisible = true
            if (row.enum_surgery_status == 10) {
                this.editButtons = [
                    {
                        label: `确认排程`,
                        type: `default`,
                        permission: `ApplySurgery:ConfirmSchedule`
                    }
                ]
            } else {
                this.editButtons = []
            }
        },
        checkedRow({ row }) {
            this.checkedRows = row
        },
        confirmChangeRoom() {
            let that = this
            if (this.changeroomids.length != 2) {
                this.$message.warning(`请选择2个手术间进行更换!`)
                return
            }
            var oldroom = that.operationRoom.find(s => s.id == this.changeroomids[0])
            var newroom = that.operationRoom.find(s => s.id == this.changeroomids[1])
            that.$confirm(`确认将 ${oldroom.name} 与 ${newroom.name} “${this.scheduling_date}”排程进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.put(`/api/Preoperative/Schedule/ExchangeRoom?roomA=${this.changeroomids[0]}&roomB=${this.changeroomids[1]}&date=${this.scheduling_date}`)
                    req.then(data => {
                        this.changeroomVisible = false
                        this.ReloadRoom()
                        this.ReloadListData()
                        that.$message.success(`交换成功`)
                    }).catch(e => {
                        // that.$message.error('交换失败')
                    })
                })
                .catch(e => {})
            console.log(`changeroomids`, this.changeroomids)
        },
        setchangeroomids(roomid) {
            if (!this.changeroomids.includes(roomid)) {
                this.changeroomids.push(roomid)
            } else {
                const targetIndex = this.changeroomids.findIndex(item => item === roomid)
                if (targetIndex !== -1) {
                    this.changeroomids.splice(targetIndex, 1)
                }
            }
        },
        loadScheduleHelper(command) {
            let that = this
            let req
            if (command == `section`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySection`, { date: that.scheduling_date })
                that.scheduling_way = 1
            }
            if (command == `worker`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgeon`, { date: that.scheduling_date })
                that.scheduling_way = 2
            }
            if (command == `surgery`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgery`, { date: that.scheduling_date })
                that.scheduling_way = 3
            }
            if (command == `autoOneKeySchedule`) {
                that.$confirm(`一键排程将对所有待排程的手术根据自定义规则进行排程,是否继续`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        that.scheduling_way = 4
                        that.myaxios.get(`/api/Preoperative/Schedule/GetOneKeyAutoSchedule`).then(data => {
                            that.ReloadRoom()
                            that.ReloadListData()
                            if (data) {
                                that.$message.success(data)
                            } else {
                                that.$message.success(`一键排程成功`)
                            }
                        }).catch(e => { })
                    })
                    .catch(e => { })
                return
            }
            if (command == `changeRoom`) {
                this.selectableRooms = this.operationRoom.filter(r => r.is_open)
                this.changeroomVisible = true
                this.changeroomids = []
                return
            }
            if (command == `setAnesDoctor`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 10) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请手术`)
                    return
                }
                that.loadsetAnesDoctorForm(surgeryIds)
                return
            }
            if (command == `clearWorkers`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请或已排程手术`)
                    return
                }
                that.loadclearWorkersForm(surgeryIds)
                return
            }
            // let req = that.myaxios.get(command == 'section'?'/api/Preoperative/Schedule/GetAutoScheduleBySection':'/api/Preoperative/Schedule/GetAutoScheduleBySurgeon',{date:that.scheduling_date})
            req.then(data => {
                that.autoScheduleSurgeries = []
                if (this.IsHavePermission(`scheduling:CrossRegionScheduling`)) {
                    that.autoScheduleSurgeries = _.filter(data, c => {
                        return _.includes(that.dic_operating_ward_id_arr, c.dic_operating_ward_id)
                    })
                } else {
                    that.autoScheduleSurgeries = _.filter(data, { dic_operating_ward_id: that.dic_operating_ward_id })
                }
                // 深拷贝一个autoScheduleColumnList
                that.autoScheduleColumnListBand = _.cloneDeep(that.autoScheduleColumnList)
                if (that.scheduling_way == 2) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeon`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                } else if (that.scheduling_way == 3) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeries`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                    var matchRule = {
                        type: `string`,
                        prop: `match_rules`,
                        label: `匹配术式`,
                        width: `120`,
                        isListable: true
                    }
                    that.autoScheduleColumnListBand.splice(4, 0, matchRule)
                }

                // that.autoScheduleSurgeries = data
            }).catch(e => {
                that.autoScheduleSurgeries = []
            })
            that.autoScheduleVisible = true
        },
        printSurenry(command) {
            // 导出Excel
            if (command == `ExportExcel`) {
                let from = this.$moment(this.scheduling_date).format(`YYYY-MM-DD`)
                let to = this.$moment(this.scheduling_date)
                    .add(1, `days`)
                    .format(`YYYY-MM-DD`)
                this.myaxios.get(`/api/Preoperative/Schedule/GetScheduleForExport`, { wardId: this.dic_operating_ward_id, from: from, to: to }).then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    // 是否需要按状态过滤
                    let filterdata = this.isEnableFilterStatusForExportExcel && this.isEnableFilterStatusForExportExcel == `1`
                    if (filterdata) {
                        this.exportExcel.exportDatas = data
                        this.exportExcel.dialogFormVisible = true
                    } else {
                        this.myaxios.export_excel(data, `手术排程.xls`)
                    }
                })
            } else {
                if (command && command.code && command.type) {
                    if (command.type == 2 || command.type == 3 || command.type == 4 || command.type == 5) {
                        // 日期阶段打印
                        this.printSurenryForm.code = command.code
                        this.printSurenryForm.type = command.type
                        this.printSurenryForm.dialogFormVisible = true
                        this.printSurenryForm.from_to = [this.$moment(this.scheduling_date).format(`YYYY/MM/DD 00:00:00`), this.$moment(this.scheduling_date).format(`YYYY/MM/DD 23:59:59`)]
                        if (command.type == 5) {
                        // 默认设置成今天
                            this.printSurenryForm.from_to = [this.$moment().format(`YYYY/MM/DD 00:00:00`), this.$moment().format(`YYYY/MM/DD 23:59:59`)]
                        }
                        this.printSurenryForm.roomids = []
                        this.printSurenryForm.wardids = []
                        if (command.extradata != null && command.extradata != ``) {
                            this.printSurenryForm.extradata = command.extradata
                        }
                        let r = _.filter(this[`operation_ward_auth`], { value: parseInt(this.dic_operating_ward_id) })
                        console.log(`手术间`)
                        this.printSurenryForm.rooms = (r && r[0] && r[0].operation_room) || []
                    } else {
                        let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                        req2.then(isShow => {
                            // 选择打印
                            // 批量打印手术通知单
                            if (command.type == 1) {
                                let printlist = []
                                if (this.checkedRows.length < 1) {
                                    printlist = this.allschedules
                                } else {
                                    printlist = this.checkedRows
                                }
                                if (printlist.length) {
                                    this.$store.dispatch(`PRINT_PDF`, {
                                        host: this.$root.DOCSERVICE_BASE,
                                        params: Object.assign(
                                            {
                                                docid: this.$root.DOCUMENT[command.code],
                                                id1: `99999`,
                                                objId: printlist.map(d => d.id).toString()
                                            },
                                            { isShowSendPrintMessage: isShow.value }
                                        )
                                    })
                                } else {
                                    this.$message.warning(`请选择需要打印的手术通知`)
                                }
                            } else {
                                // 打印当天
                                this.$store.dispatch(`PRINT_PDF`, {
                                    host: this.$root.DOCSERVICE_BASE,
                                    params: Object.assign(
                                        {
                                            docid: this.$root.DOCUMENT[command.code],
                                            id1: ``,
                                            objId: `${this.dic_operating_ward_id}|${this.scheduling_date}`,
                                            from: this.$moment(this.scheduling_date).format(`YYYYMMDDHHmm`),
                                            to: this.$moment(this.scheduling_date)
                                                .add(1, `days`)
                                                .format(`YYYYMMDDHHmm`)
                                        },
                                        { isShowSendPrintMessage: isShow.value }
                                    )
                                })
                            }
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }
            }
        },
        printSurenryByTime() {
            console.log(`printSurenryForm`, this.printSurenryForm)
            this.printSurenryForm.dialogFormVisible = false
            if (this.printSurenryForm.type == 2 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                // 自定义execl打印
                this.myaxios
                    .get(`/api/Preoperative/Schedule/GetScheduleExtradata`, {
                        wardId: this.dic_operating_ward_id,
                        from: this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`),
                        to: this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`),
                        objs: ``
                    })
                    .then(data => {
                        if (data.length <= 0) {
                            this.$message.warning(`暂无导出数据`)
                            return
                        }
                        this.myaxios.export_excel_Extradata(
                            this.printSurenryForm.extradata.ExportUrl,
                            data,
                            `手术排程.xls`,
                            `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`
                        )
                    })
            } else if (this.printSurenryForm.type == 3 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                let wardId = this.dic_operating_ward_id
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let roomids = this.printSurenryForm.roomids && this.printSurenryForm.roomids.join(`,`)
                let tempInfo = this.printSurenryForm.extradata.tempInfo
                let xlsName = `手术排程.xls`
                let shapb = `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`
                if (tempInfo) {
                    let tempArr = tempInfo.split(`|`)
                    if (tempArr.length != 2) {
                        this.$message.warning(`请确认导出模板配置`)
                        return
                    }
                    let tempname = tempArr[0]
                    let procname = tempArr[1]
                    xlsName = tempname + `.xls`
                    shapb = tempname + `(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`

                    this.myaxios
                        .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardId=${wardId}&roomids=${roomids}&from=${from}&to=${to}&procname=${procname}`, null, xlsName,
                            shapb)
                } else {
                    this.myaxios
                        .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardId=${wardId}&roomids=${roomids}&from=${from}&to=${to}`, null, xlsName,
                            shapb)
                }
            } else if (this.printSurenryForm.type == 4 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let wardids = this.printSurenryForm.wardids && this.printSurenryForm.wardids.join(`,`)
                this.myaxios
                    .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardids=${wardids}&from=${from}&to=${to}`, null, `手术排程.xls`,
                        `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`)
            } else {
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let wardids = this.printSurenryForm.wardids && this.printSurenryForm.wardids.join(`,`)
                let objIdstr = `${this.dic_operating_ward_id}|${from}-${to}`
                if (this.printSurenryForm.type == 4) {
                    objIdstr = `${wardids}|${from}-${to}`
                }
                console.log(`objId`, objIdstr)
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT[this.printSurenryForm.code],
                                id1: ``,
                                objId: objIdstr,
                                from: this.$moment(this.printSurenryForm.from_to[0]).format(`YYYYMMDDHHmm`),
                                to: this.$moment(this.printSurenryForm.from_to[1]).format(`YYYYMMDDHHmm`)
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        /* 打开选择手术间弹层 */
        openRoomSelect(row) {
            this.rowToAssign = row
            this.selectedRoomId = row.operatingid || null
            // 取当天全部手术间（已加载在 operationRoom 中）
            this.selectableRooms = this.operationRoom.filter(r => r.is_open)
            this.roomSelectVisible = true
        },
        /* 点击输入框或按回车后，打开多选弹层 */
        openCircuitNurseDialog(row, duty) {
            this.currentRow = row
            this.localSelectedNurses = []
            let fwork = _.filter(row.workerlist, function(i) {
                return i.enum_duty == duty
            })
            this.localSelectedNurses = []
            if (fwork != null) {
                this.localSelectedNurses = fwork.map(n => n.id)
            }
            this.circuitNurseVisible = true
            this.duty = duty
            this.nurseKeyword = ``
            this.$nextTick(() => {
                // 通过 ref 获取组件实例并调用 focus 方法
                if (this.$refs.nurseKeywordRef) {
                    this.$refs.nurseKeywordRef.focus()
                }
            })
        },
        /* 弹层点击确定 */
        confirmRoomSelect() {
            if (!this.selectedRoomId) {
                this.$message.warning(`请选择手术间`)
            }
            let rowsurgeon = this.rowToAssign.workerlist.find(s => s.enum_duty == 1)
            if (rowsurgeon == null) {
                this.$message.warning(`请安排手术医生`)
                return
            }
            let obj = {
                id: this.rowToAssign.id,
                dic_operating_room_id: this.selectedRoomId,
                plan_time: this.scheduling_date,
                dic_operatingward_id: this.dic_operating_ward_id,
                dic_worker_id: rowsurgeon.id
            }

            this.myaxios
                .put(`/api/Preoperative/Schedule/AutoScheduledBySurgeon`, obj)
                .then(() => {
                    this.roomSelectVisible = false
                    this.ReloadRoom()
                    this.ReloadListData()
                })
        },
        /* 弹层内切换选中 */
        toggleNurse(id) {
            const idx = this.localSelectedNurses.indexOf(id)
            idx === -1
                ? this.localSelectedNurses.push(id)
                : this.localSelectedNurses.splice(idx, 1)
        },
        ClearWorker(duty) {
            console.log(this.currentRow)
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `确定清除当前手术间的人员安排吗？`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    let rowsurgeon = this.currentRow.workerlist.find(s => s.enum_duty == 1)
                    let obj = {
                        id: this.currentRow.id,
                        plan_time: this.scheduling_date,
                        dic_worker_id: rowsurgeon.id,
                        enum_surgeryDuty: duty,
                        dic_operating_room_id: this.currentRow.operatingid,
                        dic_operatingward_id: this.dic_operating_ward_id
                    }
                    this.myaxios
                        .post(`/api/Preoperative/Schedule/AutoClearBySurgeon`, obj)
                        .then(() => {
                            this.circuitNurseVisible = false
                            this.ReloadListData()
                        }).catch(e => {
                            console.log(e)
                        })
                })
                .catch(e => {
                    console.log(e)
                })
        },
        /* 弹层多选确定 */
        confirmCircuitNurse(duty) {
            let all = this.getCircuitNurseOptions(duty)
            let nurses = all.filter(n =>
                this.localSelectedNurses.includes(n.value)
            )

            if (duty == `3` && nurses.length > 1) {
                this.$message.warning(`麻醉医生只能安排一人`)
                return
            }
            let rowsurgeon = this.currentRow.workerlist.find(s => s.enum_duty == 1)
            if (rowsurgeon == null) {
                this.$message.warning(`请安排手术医生`)
                return
            }
            let obj = {
                id: this.currentRow.id,
                plan_time: this.scheduling_date,
                dic_worker_id: rowsurgeon.id,
                enum_surgeryDuty: duty,
                selected_nurses: this.localSelectedNurses,
                dic_operating_room_id: this.currentRow.operatingid,
                dic_operatingward_id: this.dic_operating_ward_id
            }
            this.myaxios
                .put(`/api/Preoperative/Schedule/AutoSurgeryWorkerBySurgeon`, obj)
                .then(() => {
                    this.circuitNurseVisible = false
                    this.ReloadListData()
                }).catch(e => {
                    console.log(e)
                })
        },
        refreshList() {
            this.ReloadRoom()
            this.ReloadListData()
        },
        removePerson(dicworkerid) {
            console.log(dicworkerid)
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `确定清除当前人员安排吗？`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.myaxios
                        .post(`/api/Preoperative/Schedule/DelOneSurgeonById?surgeryId=${this.currentRow.id}&dic_worker_id=${dicworkerid}`)
                        .then(() => {
                            this.circuitNurseVisible = false
                            this.ReloadListData()
                        }).catch(e => {
                            console.log(e)
                        })
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadSurgeryEditView({ row }) {
            this.edit.surgeryId = row.id
            this.edit.dialogFormVisible = true
            if (row.enum_surgery_status == 10) {
                this.editButtons = [
                    {
                        label: `确认排程`,
                        type: `default`,
                        permission: `ApplySurgery:ConfirmSchedule`
                    }
                ]
            } else {
                this.editButtons = []
            }
        },
        checkSurgery(ids) {
            // 存储校验
            return new Promise((resolve, reject) => {
                let that = this // , int[] surgeryIds
                let req = that.myaxios.put(`/api/Preoperative/Schedule/CheckSurgery`, ids)
                req.then(d => {
                    resolve(d)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        afterSave(surgeryId, surgeryStatus, operatingRoomId) {
            let that = this
            let surgeryIds = []
            if (surgeryStatus == 10) {
                surgeryIds.push(surgeryId)
                that.checkSurgery(surgeryIds).then((d) => {
                    if (d && d != ``) {
                        this.$confirm(d, `提示`, {
                            confirmButtonText: `确定排程`,
                            cancelButtonText: `取消排程`,
                            type: `warning`,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                that.doScheduleSurgeries(that.scheduling_date, operatingRoomId, surgeryIds, 1)
                            })
                            .catch(e => {
                                let rooIds = [that.active_room_id]
                                this.ReScheduleSurgeries(rooIds).then(ds => {
                                    that.refreshList()
                                })
                            })
                    } else {
                        that.doScheduleSurgeries(that.scheduling_date, operatingRoomId, surgeryIds, 1)
                    }
                })
            } else {
                that.refreshList()
            }
        },
        doScheduleSurgeries(schedulingDate, operatingRoomId, surgeryIds, type) {
            let that = this
            let req = that.myaxios.put(`/api/Preoperative/Schedule/ScheduleSurgeries?date=${schedulingDate}&roomId=${operatingRoomId}`, surgeryIds)
            req.then(data => {
                let rooIds = [that.active_room_id]
                this.ReScheduleSurgeries(rooIds).then(ds => {
                    if (type == 1) {
                        that.refreshList()
                    } else if (type == 2) {
                        that.ReloadRoom()
                        that.ReloadListData()
                        that.scrolling_in_id = 0 // 把当前拖拽手术间置空
                    } else if (type == 3) {
                        that.ReloadRoom()
                        that.ReloadListData()
                        that.changeRoom.dialogFormVisible = false
                    }
                    that.$message.success(`排程成功`)
                })
            }).catch(e => {
                that.$message.error(`排程失败`)
            })
        },
        LoadActiveRoomData(event, room) {
            let that = this
            let scrollLeft = that.$refs.scrollpaneRef && that.$refs.scrollpaneRef.scrollWrapper.scrollLeft
            if (this.active_room_id == room.id) {
                this.active_room_id = 0
            } else {
                this.isLoadToSchedule = false
                this.isLoadScheduled = false
                this.isLoadAll = false
                this.active_room_id = room.id
                this.ReloadListData()
                this.$nextTick(() => {
                    if (that.$refs.scrollpaneRef) {
                        let $scrollWrapper = that.$refs.scrollpaneRef.scrollWrapper
                        $scrollWrapper.scrollLeft = scrollLeft
                    }
                })
            }
        },
        ReloadRoom() {
            // GET /api/Preoperative/Schedule/GetRooms
            let that = this
            let req = this.myaxios.get(`/api/Preoperative/Schedule/GetRoomsLineList`, { date: that.scheduling_date })
            req.then(data => {
                that.operation_ward_all = _.groupBy(data, `dic_operating_ward_id`)
                this.$nextTick(() => {
                    that.thistableHeight = (this.$refs[`roomrow`] && this.$refs[`roomrow`].offsetHeight)
                })
            }).catch(e => {
                console.log(e)
            })
        },
        roomDragOption(isopen) {
            return {
                animation: 0,
                group: { name: `room`, put: [`listview`, `fixed-listview`], pull: false },
                disabled: !isopen,
                ghostClass: `ghost`,
                sort: false
            }
        },
        rowStyle() {
            return {
                height: `28px`
            }
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        changed(changed) {
            this.selectsurgeryType = changed
            this.ReloadListData()
        },
        loadPrintSurgeryConfig() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=PrintSurgeryConfig`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.printSurgeryConfigs = JSON.parse(data.value)
                    } else {
                        this.printSurgeryConfigs = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        putScheduled(data) {
            let that = this
            let roomIds = []
            let reqs = data.map(d => {
                let info = _.filter(this.allschedules, { id: d.id })[0]
                if (info != null) {
                    roomIds.push(info.operatingid)
                }

                d.scheduled_sequence = d.scheduledsequence
                // d.plan_anes_doctor = d.plan_anes_doctor == `` || d.plan_anes_doctor < 0 ? -1 : d.plan_anes_doctor && d.plan_anes_doctor.value
                // d.plan_anes_assistants = d.plan_anes_assistants && d.plan_anes_assistants.map(a => a && a.value)
                // d.plan_circuit_nurse = d.plan_circuit_nurse && d.plan_circuit_nurse.map(a => a && a.value)
                // d.plan_equipment_nurse = d.plan_equipment_nurse && d.plan_equipment_nurse.map(a => a && a.value)
                // d.plan_anaes_methods = d.plan_anaes_methods && d.plan_anaes_methods.map(a => a && a.value)
                // if (info != null) {
                //     d.visit_info = {
                //         id: info.visit_id,
                //         enum_visit_type: info.enum_visit_type,
                //         visit_no: info.visit_no,
                //         outpatient_no: info.outpatient_no,
                //         name: info.patient_name
                //     }
                // }
                return this.myaxios.put(`/api/Preoperative/Schedule/UpdateSchedule`, d)
            })
            return new Promise((resolve, reject) => {
                let req = this.myaxios.all(...reqs)
                req.then(res => {
                    // isAutoScheduledSequence参数为1则自动重置台次
                    if (that.isAutoScheduledSequence == `1`) {
                        this.ReScheduleSurgeries(roomIds).then(ds => {
                            this.ReloadListData()
                            that.$message.success(`保存成功`)
                            resolve(res)
                        })
                    } else {
                        this.ReloadListData()
                        that.$message.success(`保存成功`)
                        resolve(res)
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        },
        ReScheduleSurgeries(roomIds) {
            let that = this
            return new Promise(resolve => {
                let req = that.myaxios.put(`/api/Preoperative/Schedule/ReScheduleSurgeries?date=${that.scheduling_date}`, roomIds)
                req.then(data => {
                    resolve([])
                }).catch(e => {
                    that.$message.error(`取消后重新调整台次失败!`)
                })
            })
        },
        loadSurgeries() {
            let that = this
            return new Promise(resolve => {
                let activeroomid = this.active_room_id || 0
                let operatingwardid = this.dic_operating_ward_id || 0
                // 获取排程数据
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetScheduledSimpleList`, { date: that.scheduling_date, dic_operating_ward_id: operatingwardid, active_room_id: activeroomid })
                this.myaxios.all(req).then(([data]) => {
                    const start = Date.now()
                    if (data.length > 0 && that.selectsurgeryType > 0) {
                        if (that.selectsurgeryType == 1 || that.selectsurgeryType == 2) {
                            data = _.filter(data, function(i) {
                                return i.enum_surgerytype == that.selectsurgeryType
                            })
                        }
                        if (that.selectsurgeryType == 3) {
                            data = _.filter(data, function(i) {
                                return i.is_day_surgery == true
                            })
                        }
                    }
                    let r = data.map(d => {
                        d.sequence_s = this.IsNum(d.sequence) ? parseInt(d.sequence) : d.sequence
                        d.sequence_apply = this.IsNum(d.sequence) ? parseInt(d.sequence) : null
                        d.scheduled_sequence_num = this.IsNum(d.scheduled_sequence) ? parseInt(d.scheduled_sequence) : d.scheduled_sequence
                        // 手术区域处理
                        if (this.surgeryNameConfig && this.surgeryNameConfig.includes(`Surgery_Region`) && d.surgery_region) {
                            d.surgeries = d.surgery_region.map(sr =>
                                `${sr.surgery_name}${sr.surgery_region ? this.surgeryNameConfig.replace(`Surgery_Region`, sr.surgery_region) : ``}`
                            ).join(`,`)
                        }
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        // 行样式 scheduleSurgeryRowStyleObj
                        if (that.scheduleSurgeryRowStyleObj) {
                            let rowStyle = {}
                            if (d.infectious && that.scheduleSurgeryRowStyleObj.infectiousInfo && _.includes(that.scheduleSurgeryRowStyleObj.infectiousInfo, d.infectious)) { // 已确认
                                rowStyle.color = `${that.scheduleSurgeryRowStyleObj.infectious} !important`
                            }
                            if (that.scheduleSurgeryRowStyleObj.AgeTipConfig && that.scheduleSurgeryRowStyleObj.AgeTipConfig.length > 0) { // 年龄
                                var TipInfo = that.scheduleSurgeryRowStyleObj.AgeTipConfig.filter(i => {
                                    return i.Min <= d.ageint && i.Max >= d.ageint
                                })
                                if (TipInfo && TipInfo.length > 0) {
                                    rowStyle.color = `${TipInfo[0].FontColor} !important`
                                }
                            }
                            if (d.enum_surgerytype == 1 && that.scheduleSurgeryRowStyleObj.surgerytypeJZ) {
                                rowStyle.color = `${that.scheduleSurgeryRowStyleObj.surgerytypeJZ} !important`
                            } else if (d.enum_surgerytype == 2 && that.scheduleSurgeryRowStyleObj.surgerytypeZQ) {
                                rowStyle.color = `${that.scheduleSurgeryRowStyleObj.surgerytypeZQ} !important`
                            }
                            d.row_style = rowStyle
                        }

                        // reload的时候把动态列字段放到obj对象里面
                        // this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        return d
                    })
                    let r1 = _.filter(r, { enum_surgery_status: 10 })
                    let r2 = _.filter(r, function(i) {
                        return i.enum_surgery_status > 10
                    })
                    if (activeroomid == 0) {
                        that.unScheduledLength = r1.length || 0
                        that.ScheduledLength = r2.length || 0
                    }

                    that.unschedulelist = that.isLoadToSchedule || that.isLoadAll ? r1 : []
                    that.scheduledlist = that.isLoadScheduled || that.isLoadAll || activeroomid > 0 ? r2 : []

                    that.allschedules = that.unschedulelist.concat(that.scheduledlist)
                    console.log(`allschedules`, that.allschedules)
                    const end = Date.now()
                    console.log(`执行时间：${end - start}ms`)
                    resolve(that.allschedules)
                })
            })
        },
        ReloadListData() {
            if (this.$refs[`surgery-list`]) {
                this.$refs[`surgery-list`].ReloadListData()
            }
        },
        closewbase() {
            this.itemdetail.dialogFormVisible = false
        },
        loadRoomStyle() {
            let config = JSON.parse(this.ScheduleRoomStyleSetting)
            if (config.字体颜色) {
                this.roomStyle.color = config.字体颜色
            } else {
                this.roomStyle.color = ``
            }
            let fontsize = parseInt(config.字体大小)
            if (fontsize && fontsize > 0) {
                this.roomStyle.fontSize = fontsize + `px`
            } else {
                this.roomStyle.fontSize = ``
            }
            if (config.背景色) {
                this.roomStyle.backgroundColor = config.背景色
            } else {
                this.roomStyle.backgroundColor = ``
            }

            if (config.选中后字体颜色) {
                this.roomStyle.activecolor = config.选中后字体颜色
            }
            let activefontsize = parseInt(config.选中后字体大小)
            if (activefontsize && activefontsize > 0) {
                this.roomStyle.activefontSize = activefontsize + `px`
            }
            if (config.选中后背景色) {
                this.roomStyle.activebackgroundColor = config.选中后背景色
            }

            let config2 = JSON.parse(this.settingRoomBgColor)
            if (config2.是否启用) {
                this.roomStyle.isEnable = config2.是否启用
            }
            if (config2.是否启用 && config2.是否启用 === `1`) {
                if (config2.背景色) {
                    this.roomStyle.bgColor = config2.背景色
                }
                if (config2.选中后背景色) {
                    this.roomStyle.activebgColor = config2.选中后背景色
                }
            }
        },
        IsNum(value) {
            return !isNaN(value)
        },
        /// 开始滚动
        startScroll(e, direction) {
            e.preventDefault()
            let that = this
            this.setIntervalScroll = window.setInterval(
                direction => {
                    this.$nextTick(() => {
                        if (that.$refs.scrollpaneRef) {
                            let $scrollWrapper = that.$refs.scrollpaneRef.scrollWrapper
                            $scrollWrapper.scrollLeft = direction == `left` ? $scrollWrapper.scrollLeft - 2 : $scrollWrapper.scrollLeft + 2
                        }
                    })
                },
                5,
                direction
            )
        },
        endScroll(e) {
            let that = this
            e.preventDefault()
            window.clearInterval(that.setIntervalScroll)
        },
        dragover(e) {
            e.preventDefault()
        },
        clearButtonFocus() {
            this.$nextTick(() => {
                let active = document.activeElement
                if (active && typeof active.blur === `function`) {
                    active.blur()
                }
            })
        },
        LoadUnScheduled() {
            this.isLoadToSchedule = true
            this.isLoadScheduled = false
            this.isLoadAll = false
            this.active_room_id = 0
            this.clearButtonFocus()
            // 触发更新列表
            this.ReloadListData()
        },
        LoadScheduled() {
            this.isLoadToSchedule = false
            this.isLoadScheduled = true
            this.isLoadAll = false
            this.active_room_id = 0
            this.clearButtonFocus()
            // 触发更新列表
            this.ReloadListData()
        },
        LoadAllScheduled() {
            this.isLoadToSchedule = false
            this.isLoadScheduled = false
            this.isLoadAll = true
            this.active_room_id = 0
            this.clearButtonFocus()
            // 触发更新列表
            this.ReloadListData()
        },
        ishavehelpSection(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return (
                    this.permissions &&
                    this.permissions.findIndex(
                        item =>
                            item.permission === `scheduling:helpSection` ||
                            item.permission === `scheduling:helpWorker` ||
                            item.permission === `scheduling:helpSurgery` ||
                            item.permission === `scheduling:helpChangeRoom` ||
                            item.permission === `scheduling:helpSetAnesDoctor` ||
                            item.permission === `scheduling:helpOneKeySchedule` ||
                            item.permission === `scheduling:clearWorkersSettings`
                    ) != -1
                )
            }
        }
    },
    watch: {
        dic_operating_ward_id: function(newVlaue, oldValue) {
            // sessionStorage.setItem(`memory_operating_ward_id`, newVlaue)
            // 更改日期触发更新列表
            this.ReloadRoom()
            this.ReloadListData()
        },
        scheduling_date: function() {
            this.ReloadRoom()
            this.ReloadListData()
        },
        searchchargeType: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style scoped lang="less">
/* 拖拽时的样式控制 */
/deep/.room tr {
    display: none ;
}

.room .drag_target {
    color: black !important;
    outline: dotted 0.5px gray;
}

.surgery-status-tag {
    width: 12px;
    float: left;
}

.surgery-num-tag {
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    // display: -moz-inline-box; /* css注释：for ff2 */
    // display: inline-block;
    float: right;
    margin-top: 8px;
}

.el-tag-dp {
    color: #52b8d2;
    border-color: #52b8d2;
    background-color: white;
}

.workerImg {
    float: left;
    padding: 2px 15px;
    width: 16px;
    height: 16px;
}

.workerImg:hover {
    cursor: pointer;
    transform: scale(1.2);
}

.more {
    height: 50px;
    line-height: 45px;
    margin-left: 10px;
    border-radius: 5px;
}

.more:hover {
    cursor: pointer;
    border: solid 0.5px var(--primary-color, #009688);
    font-weight: bold;
    color: var(--primary-color, #009688);
    opacity: 1;
}
.room-card {
  margin: 4px;
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  background: #ecf5ff;
  color: #409eff;
}
.room-card:hover,
.room-card.active {
  background: #409eff;
  color: #fff;
}
.group-title {
  font-weight: bold;
  margin: 12px 0 6px;
}
.blue { color: #409EFF; }
.yellow { color: #E6A23C; }

.nurse-group {
  margin-bottom: 12px;
}
.nurse-tag {
  position: relative;
  padding: 6px 10px;
  margin-bottom: 6px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  border: 1px solid #dcdcdc;
  transition: all .2s;
  display: inline-block;
}
.nurse-tag.selected {
  background: var(--primary-color, #009688);
  color: #fff;
  border-color: var(--primary-color, #009688);
}
.delete-icon {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 16px;
        height: 16px;
        background-color: #f56c6c;
        border-radius: 50%;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        cursor: pointer;
        transition: all 0.3s;
}
.delete-icon:hover {
    background-color: #f78989;
    transform: scale(1.1);
}
// /deep/ .el-table {
//     font-size: 14px !important;
//     color: black !important;
// }
/deep/.el-table th  {
     line-height: 24px !important;
     height: 24px!important;
     padding: 0 !important;
}
/deep/.el-table th .cell {
    padding-left: 0px !important;
    padding-right: 0px !important;
     white-space: nowrap;
    //  line-height: 20px !important;
}
/deep/ .el-table .caret-wrapper{
    height: 33px;
}
/deep/.el-table td {
    // padding: 1px 1px !important;
    padding: 0 !important;
}
/deep/ .el-table td .cell {
    // padding-left: 1px !important;
    // padding-right: 1px !important;
    max-height: 35px !important;
    line-height: 35px;
}
/deep/ .el-table td .ellipsis {
    max-height: 35px !important;
    line-height: 35px;
    // span{
    //     line-height: 30px;
    // }
}
/deep/ .el-table__header .cell {
    max-height: 35px !important;
    line-height: 35px;
}
// /deep/.el-table th {
//     padding: 1px 1px !important;
// }

</style>



// WEBPACK FOOTER //
// src/components/Scheduling/ScheduleSurgerySimple.vue